import H from "history"

export function getRelativeOrAbsoluteUrl(url: string | null) {
    if (!url)
        return null;

    if (url.indexOf("http") === 0) {
        let toBeExcluded = location.origin + process.env.PUBLIC_URL;
        if (url.indexOf(toBeExcluded) === 0) {
            let path = url.substring(toBeExcluded.length);
            return path;
        }
        else {
            return url;
        }
    }
    else {
        if (url.indexOf(process.env.PUBLIC_URL) === 0)
            url = url.substr(process.env.PUBLIC_URL.length);
        return url;
    }
}

export function navigateOrPush(history: H.History, url: string | null) {
    if (!url)
        return;

    if (url.indexOf("http") === 0) {
        let toBeExcluded = location.origin + process.env.PUBLIC_URL;
        if (url.indexOf(toBeExcluded) === 0) {
            let path = url.substring(toBeExcluded.length);
            history.push(path);
        }
        else {
            window.location.href = url;
        }
    }
    else {
        if (url.indexOf(process.env.PUBLIC_URL) === 0)
            url = url.substr(process.env.PUBLIC_URL.length);
        history.push(url);
    }
}